<template>
  <div>
    <a-layout-header>
      <a-row>
        <a-col :span="12">
          <p>
            <span class="title">{{ title }}</span>-
            <span class="subTitle">{{ subTitle }}</span>
          </p>
        </a-col>
        <a-col :span="1" :offset="7">
          <a-dropdown placement="topCenter">
            <a-badge :dot="show.dot">
              <a-avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" icon="user"
                        size="small"/>
              <a href="#" class="head-example"/>
            </a-badge>
            <a-menu slot="overlay">
              <!--              <a-menu-item :key="1" @click="showNoticeCenter">-->
              <!--                <a-badge :dot="show.dot">-->
              <!--                  <a-icon type="notification"/>-->
              <!--                  消息中心-->
              <!--                </a-badge>-->
              <!--              </a-menu-item>-->
              <a-menu-item :key="1" @click="showUpdateUserInfo">
                <a-icon type="user"/>
                账号管理
              </a-menu-item>
              <a-menu-item :key="2" @click="showUpdatePassword">
                <a-icon type="user"/>
                修改密码
              </a-menu-item>
              <a-menu-item :key="3" @click="logout">
                <a-icon type="close"/>
                退出登录
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> Button
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </a-col>
        <a-col :span="4">
          <span>{{ userInfo.regionName }}</span>
          <span>{{ userInfo.name }}</span>
        </a-col>
      </a-row>
    </a-layout-header>
    <a-modal title="账号管理" :visible.sync="show.updateUserInfo" width="25%" ok-text="确认" cancel-text="取消"
             @ok="submitUpdateUserInfo" @cancel="closeUpdateUserInfo">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="name" label="姓名" prop="name">
          <a-input v-model="form.name"/>
        </a-form-model-item>
        <a-form-model-item ref="gender" label="性别" prop="gender">
          <a-radio-group name="radioGroup" v-model="form.gender">
            <a-radio value="男">男</a-radio>
            <a-radio value="女">女</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item ref="phone" label="联系电话" prop="phone">
          <a-input v-model="form.phone"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="修改密码" :visible.sync="show.updatePassword" width="25%" ok-text="确认" cancel-text="取消"
             @ok="submitUpdatePassword" @cancel="closeUpdatePassword">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="password" label="原密码" prop="password">
          <a-input-password v-model="form.password"/>
        </a-form-model-item>
        <a-form-model-item ref="newPassword" label="新密码" prop="newPassword">
          <a-input-password v-model="form.newPassword"/>
        </a-form-model-item>
        <a-form-model-item ref="rePassword" label="重复密码" prop="againPassword">
          <a-input-password v-model="form.againPassword"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="消息中心" :visible.sync="show.noticeCenter" width="50%" :footer="null" @cancel="closeNoticeCenter">
      <a-list size="small" bordered :data-source="messages">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <span>{{ item }}</span>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import CommonApi from "@/api/CommonApi";
import {SysApis} from "@/api/SysApis";

export default {
  name: "C-PageHeader",
  props: {
    title: {
      type: String,
      default: '标题'
    },
    subTitle: {
      type: String,
      default: '副标题'
    },
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'change'},
          {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
          {whitespace: true, message: '请输入名称', trigger: 'change'}
        ],
        phone: [
          {required: true, message: '请输入电话', trigger: 'change'},
          {whitespace: true, message: '请输入电话', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16个字符', trigger: 'change'},
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        password: [
          {required: true, message: '请输入原密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16位', trigger: 'change'},
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16位', trigger: 'change'},
        ],
        againPassword: [
          {required: true, message: '请重复新密码', trigger: 'change'},
          {min: 8, max: 16, message: '长度为8-16位', trigger: 'change'},
        ],
      },
      form: {
        name: '',
        phone: '',
        gender: '',
        password: '',
        newPassword: '',
        againPassword: ''
      },
      show: {
        updateUserInfo: false,
        updatePassword: false,
        dot: false,
        noticeCenter: false,
      },
      socket: null,
      messages: []
    };
  },
  activated() {
  },
  mounted() {
    // this.openWs()
    // this.$router.push({name: 'welcome'})
  },
  methods: {
    openWs() {
      const _this = this
      let wsUrl = SysApis.wsUrl
      console.log(typeof (WebSocket) === "undefined")
      if (typeof (WebSocket) === "undefined") {
        _this.$message.error('消息中心连接失败')
      } else {
        _this.socket = new WebSocket(wsUrl)
        _this.socket.onopen = () => {
          console.log("socket连接成功")
        }
        _this.socket.onerror = () => {
          console.log("连接错误")
        }
        _this.socket.onmessage = (msg) => {
          // this.show.dot = true
          console.log(msg.data)
        }
      }
    },
    showNoticeCenter() {
      this.show.noticeCenter = true
    },
    closeNoticeCenter() {
      this.show.noticeCenter = false
    },
    showUpdateUserInfo() {
      this.show.updateUserInfo = true
    },
    closeUpdateUserInfo() {
      this.show.updateUserInfo = false
      this.$refs.ruleForm.resetFields();
    },
    submitUpdateUserInfo() {
      this.form.id = this.userInfo.id
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.info('success', this.form);
          this.$http.post(SysApis.updateUserInfo, this.form).then(result => {
            if (result.status !== 200) {
              this.$message.error(result.message);
              return;
            }
            this.$message.success(result.message);
            this.closeUpdateUserInfo()
          }).catch(function (error) {
            console.error('出现错误:', error);
          });
        } else {
          console.log('验证失败');
          return false;
        }
      })
    },
    showUpdatePassword() {
      this.show.updatePassword = true
    },
    closeUpdatePassword() {
      this.show.updatePassword = false
      this.$refs.ruleForm.resetFields();
    },
    submitUpdatePassword() {
      this.form.id = this.userInfo.id
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.info('success', this.form);
          if(!this.checkPassWord(this.form.newPassword, this.form.againPassword)){
          	return;
          }else if (this.form.newPassword !== this.form.againPassword) {
            this.$message.error('两次密码不一致');
            return
          }
          this.$http.post(SysApis.updatePassword, this.form).then(result => {
            if (result.status !== 200) {
              this.$message.error(result.message);
              return;
            }
            this.$message.success(result.message);
            this.closeUpdatePassword()
          }).catch(function (error) {
            console.error('出现错误:', error);
          });
        } else {
          console.log('验证失败');
          return false;
        }
      })
    },
    logout() {
      CommonApi.logout()
    },
    checkPassWord(pwd, repeatPwd){
    	console.log(pwd);
    	console.log(repeatPwd);
    	let temp = true;
    	if(!pwd){
    		temp = false;
    	}else if(!this.checkPwdRule(pwd)){
	    	this.$message.error('密码需包含大小写字母、数字、符号，且不能出现类似111、aaa、123、abc的情况，长度8-16位！');
	    	temp = false;
    	}else if(repeatPwd !== pwd){
    		this.$message.error('重复密码与密码需一致！');
    		temp = false;
    	}
    	return temp;
    },
    checkPwdRule(pwd){
    	let temp = false;
    	let pwdRegx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z\d\W]{8,16}$/;
    	if(pwdRegx.test(pwd)){
    		let samePwdRegx = /(\w)*(\w)\2{2}(\w)*/g;
    		if(!samePwdRegx.test(pwd)&&this.checkLxPwd(pwd)){
	    		temp = true;
    		}
    	}
    	return temp;
    },
    checkLxPwd(pwd){
    	let pwdArr = pwd.split('');
    	let temp = true;
    	for(let i=1; i<pwdArr.length-1; i++){
    		let prevIndex = pwdArr[i-1].charCodeAt(),
    			nowIndex = pwdArr[i].charCodeAt(),
    			nextIndex = pwdArr[i+1].charCodeAt();
    		if((nextIndex-nowIndex) === 1&&(nowIndex-prevIndex) === 1){
    			temp = false;
    			break;
    		}
    	}
    	return temp;
    }
  }
}
</script>

<style scoped lang="less">
@import "~@public/color.less";

p {
  padding: 0;
  margin: 0;
}

.title {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
}

.ant-layout-header {
  background: @primary-color;
  color: #fff;
  height: 7vh;
  line-height: 7vh;
}

.ant-layout-footer {
  background: @primary-color;
  color: #fff;
  height: 10vh;
  line-height: 7vh;
}

.ant-layout-sider {
  width: 100%;
  height: 83vh;
  background: #fff;
}

.ant-layout-content {
  box-shadow: inset 0 0 5px fade(@primary-color, 20%);
  padding: 12px;
  background: #fff;
  min-height: 120px;
  height: 83vh;
  overflow: auto;
}

/*滚动条整体样式*/
.ant-layout-content::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-right: 10px;
  opacity: 0.2;
}

/*滚动条里面小方块(滑块 )*/
.ant-layout-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}

/*滚动条里面轨道(背景)*/
.ant-layout-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  border-radius: 10px;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}
</style>
